import { Route } from 'react-router-dom';
import {
  Home,
  Products,
  Checkout,
  ManageOrders,
  ViewRemovedItems,
  CreateProduct,
  ManageProducts,
} from '../pages';

const GenStack = (
  <Route>
    {[
      { path: '/', element: <Home /> },
      { path: '/products', element: <Products /> },
      { path: '/checkout', element: <Checkout /> },
      { path: '/admin/view_removed_items', element: <ViewRemovedItems /> },
      { path: '/admin/manage_orders', element: <ManageOrders /> },
      { path: '/admin/create_product', element: <CreateProduct /> },
      { path: '/admin/manage_products', element: <ManageProducts /> },
    ].map((r, ind) => (
      <Route key={ind} exact path={r.path} element={r.element} />
    ))}
  </Route>
);

export default GenStack;
